"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Label = void 0;

var tslib_1 = require("tslib");

var ui_blocks_1 = require("@hopin-team/ui-blocks");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_text_1 = require("@hopin-team/ui-text");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var input_1 = require("./input");

var switch_1 = require("./switch");

var base = ui_blocks_1.INTERACTIVE.base,
    isDisabled = ui_blocks_1.INTERACTIVE.isDisabled;
exports.Label = (0, styled_components_1.default)(ui_text_1.Text)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  ", "\n  display: flex;\n  align-items: center;\n  position: relative;\n  gap: 0.75rem;\n  cursor: ", ";\n\n  ", ":focus-visible + ", "::before {\n    outline: 0.125rem solid\n      ", ";\n    outline-offset: 0.125rem;\n  }\n\n  ", ":disabled + ", "::before {\n    ", "\n    background: ", "\n  }\n"], ["\n  ", "\n  display: flex;\n  align-items: center;\n  position: relative;\n  gap: 0.75rem;\n  cursor: ", ";\n\n  ", ":focus-visible + ", "::before {\n    outline: 0.125rem solid\n      ", ";\n    outline-offset: 0.125rem;\n  }\n\n  ", ":disabled + ", "::before {\n    ", "\n    background: ", "\n  }\n"])), base, function (_a) {
  var isDisabled = _a.isDisabled;
  return isDisabled && 'not-allowed;';
}, input_1.Input, switch_1.Switch, function (_a) {
  var isInverse = _a.isInverse,
      theme = _a.theme;
  return isInverse ? (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.WHITE', theme) : (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.UTILITY.ACTION', theme);
}, input_1.Input, switch_1.Switch, isDisabled, function (_a) {
  var isInverse = _a.isInverse,
      theme = _a.theme;
  return isInverse && (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.MEDIUM', theme);
});
var templateObject_1;